import React from "react";
import SimpleChannelTestPage from "./SimpleChannelTestPage";

export const SmsTestPage: React.FC = () => (
  <SimpleChannelTestPage channel="sms" />
);

export default SmsTestPage;
